import axios from 'axios';

export const nestPost = async (
  typeApi: string,
  path: string,
  headers: any,
  postData: any,
  query = '',
) => {
  let result = null;
  let prefix;

  switch (typeApi) {
    case 'payments':
      prefix = process.env.VUE_APP_NESTJS_PAYMENT_API_URL;
      break;
    case 'esr':
      prefix = process.env.VUE_APP_NESTJS_ESR_API_URL;
      break;
    case 'v5':
      prefix = process.env.VUE_APP_NESTJS_V5_API_URL;
      break;
    default:
      prefix = process.env.VUE_APP_NESTJS_API_URL;
      break;
  }

  const url = `${prefix}${path}${query}`;
  const formattedHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...headers,
  };

  try {
    const process = await axios.post(
      url,
      postData, { headers: formattedHeaders },
    );

    if (process && process.data) {
      result = process.data;
    }
  } catch (error: any) {
    result = null;
    if (error.response && error.response.data) {
      return { error: error.response.data };
    }
    if (error.message) {
      return { error: error.message };
    }
  }

  return result;
};

export const nestGet = async (
  typeApi: string,
  path: string,
  headers: any,
  query = '',
) => {
  let result = null;
  let prefix;

  switch (typeApi) {
    case 'payments':
      prefix = process.env.VUE_APP_NESTJS_PAYMENT_API_URL;
      break;
    case 'esr':
      prefix = process.env.VUE_APP_NESTJS_ESR_API_URL;
      break;
    case 'v5':
      prefix = process.env.VUE_APP_NESTJS_V5_API_URL;
      break;
    default:
      prefix = process.env.VUE_APP_NESTJS_API_URL;
      break;
  }

  const url = `${prefix}${path}${query}`;

  const formattedHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...headers,
  };

  try {
    const process = await axios.get(
      url,
      { headers: formattedHeaders },
    );

    if (process && process.data) {
      result = process.data;
    }
  } catch (error) {
    result = null;
  }

  return result;
};

/**
 * Récupère le token JWT depuis le cookie api_token_v2
 */
const getJwtTokenFromCookie = (): string | null => {
  const cookies = document.cookie.split(';');
  const apiTokenCookie = cookies
    .map((cookie) => cookie.trim().split('='))
    .find(([name]) => name === 'api_token_v2');

  return apiTokenCookie ? decodeURIComponent(apiTokenCookie[1]) : null;
};

/**
 * Fonction pour communiquer avec NestJS de manière sécurisée
 */
export const securedNestPost = async (
  typeApi: string,
  path: string,
  headers: any = {},
  postData: any,
  query = '',
) => {
  let result = null;
  let prefix;

  switch (typeApi) {
    case 'payments':
      prefix = process.env.VUE_APP_NESTJS_PAYMENT_API_URL;
      break;
    case 'esr':
      prefix = process.env.VUE_APP_NESTJS_ESR_API_URL;
      break;
    case 'v5':
      prefix = process.env.VUE_APP_NESTJS_V5_API_URL;
      break;
    default:
      prefix = process.env.VUE_APP_NESTJS_API_URL;
      break;
  }

  const url = `${prefix}${path}${query}`;

  // Récupération du token JWT
  const jwtToken = getJwtTokenFromCookie();

  const formattedHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...headers,
  };

  // Ajout du token JWT dans le header Authorization si disponible
  if (jwtToken) {
    formattedHeaders.Authorization = `Bearer ${jwtToken}`;
  }

  try {
    const process = await axios.post(
      url,
      postData,
      {
        headers: formattedHeaders,
        withCredentials: true, // Important: envoie automatiquement les cookies
      },
    );

    if (process && process.data) {
      result = process.data;
    }
  } catch (error: any) {
    result = null;

    // Gestion spécifique des erreurs d'authentification
    if (error.response) {
      const { status, data } = error.response;

      // Erreurs d'authentification/autorisation
      if (status === 401 || status === 403) {
        return {
          error: {
            ...data,
            isAuthError: true,
            status,
          },
        };
      }

      return { error: data };
    }

    if (error.message) {
      return { error: error.message };
    }
  }

  return result;
};

/**
 * Variante GET sécurisée — JWT depuis cookie api_token_v2.
 */
export const securedNestGet = async (
  typeApi: string,
  path: string,
  headers: any = {},
  query = '',
) => {
  let result = null;
  let prefix;

  switch (typeApi) {
    case 'payments':
      prefix = process.env.VUE_APP_NESTJS_PAYMENT_API_URL;
      break;
    case 'esr':
      prefix = process.env.VUE_APP_NESTJS_ESR_API_URL;
      break;
    case 'v5':
      prefix = process.env.VUE_APP_NESTJS_V5_API_URL;
      break;
    default:
      prefix = process.env.VUE_APP_NESTJS_API_URL;
      break;
  }

  const url = `${prefix}${path}${query}`;

  const jwtToken = getJwtTokenFromCookie();

  const formattedHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...headers,
  };

  if (jwtToken) {
    formattedHeaders.Authorization = `Bearer ${jwtToken}`;
  }

  try {
    const process = await axios.get(
      url,
      {
        headers: formattedHeaders,
        withCredentials: true,
      },
    );

    if (process && process.data) {
      result = process.data;
    }
  } catch (error: any) {
    result = null;

    if (error.response) {
      const { status, data } = error.response;

      if (status === 401 || status === 403) {
        return {
          error: {
            ...data,
            isAuthError: true,
            status,
          },
        };
      }

      return { error: data };
    }

    if (error.message) {
      return { error: error.message };
    }
  }

  return result;
};
